import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  header: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[5],
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[5],
  },
  contentHidden: {
    display: "none",
  },
  title: {
    fontSize: designTokens.fontSize.xl,
    fontWeight: designTokens.fontWeight.bold,
    color: designTokens.primary[800],
  },
  toggle: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "24px",
    minHeight: "24px",
    padding: "0",
    background: designTokens.neutral.white,
    border: `1px solid ${designTokens.primary[100]}`,
    borderRadius: designTokens.borderRadius.sm,
    cursor: "pointer",
    color: designTokens.accent[700],
    ":hover": {
      backgroundColor: designTokens.primary[50],
      color: designTokens.accent[600],
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "2px",
    },
  },
});
